import { render, staticRenderFns } from "./FormFcontinuecreate.vue?vue&type=template&id=73d2154c&"
import script from "./FormFcontinuecreate.vue?vue&type=script&lang=js&"
export * from "./FormFcontinuecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports